<template>
  <a-modal
    ref="createModal"
    :title="`新建${currentTab}`"
    :width="900"
    :visible="visible"
    :maskClosable="false"
    okText="保存"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <div class="table-page-operator-wrapper">
      <a-button @click="addLine()" type="primary">新增行</a-button>
    </div>
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="tableList"
      :pagination="false"
      row-key="indexId"
      :scroll="{ x: tableX, y: 260 }"
    >
      <!-- 计划类型 -->
      <span slot="planTypeTitle">
        <i class="toRequired">*</i>计划类型
      </span>
      <template slot="planType" slot-scope="text, record">
        <global-select
          :value.sync="record.planType"
          requestApi="/system/lookup/data/list"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
          :setParams="{ lookupType: 'INV_ALLOCATION_PLAN_TYPE' }"
          :allowClear="false"
          @change="planTypeChange(record)"
        />
      </template>
      <!-- 仓库 -->
      <template slot="warehouse" slot-scope="text, record">
        <global-select
          :value.sync="record.warehouse"
          requestApi="/system/lookup/data/list"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
          :setParams="{ lookupType: '4PL_WAREHOUSE_DESCRIPTION' }"
          :allowClear="false"
          :disabled="ptList.includes(record.planType)"
        />
      </template>
      <!-- 存货区域 -->
      <span slot="maintenanceValueTitle">
        <i class="toRequired">*</i>存货区域
      </span>
      <template slot="areaCode" slot-scope="text, record">
        <global-select
          :value.sync="record.areaCode"
          requestApi="/system/lookup/data/list"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
          :setParams="{ lookupType: 'INV_DEFAULT_AREA' }"
          :allowClear="false"
        />
      </template>
      <!-- 订单满足率 -->
      <span slot="satisfyRateTitle">
        <i class="toRequired">*</i>订单满足率
      </span>
      <template slot="satisfyRate" slot-scope="text, record">
        <a-input-number v-model="record['satisfyRate']" :min="0" :max="100" />
      </template>
      <!-- 欠货天数 -->
      <span slot="oweGoodsDayTitle">
        <i class="toRequired">*</i>欠货天数
      </span>
      <template slot="oweGoodsDay" slot-scope="text, record">
        <a-input-number
          v-model="record['oweGoodsDay']"
          :min="0"
          :parser="(value) => `${value}`.replace(/\D/g, '')"
          :formatter="(value) => `${value}`.replace(/\D/g, '')" />
      </template>
      <!-- 计算方式 -->
      <span slot="calculationTypeTitle">
        <i class="toRequired">*</i>计算方式
      </span>
      <template slot="calculationType" slot-scope="text, record">
        <a-select v-model="record['calculationType']" :allowClear="false">
          <a-select-option v-for="(item) in calculationTypeList" :key="item.code" :value="item.code" :label="item.name">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </template>
      <!-- 物料编码 -->
      <span slot="itemIdTitle">
        <i class="toRequired">*</i>物料编码
      </span>
      <template slot="itemCode" slot-scope="text, record, index">
        <global-select
          :dropdown-match-select-width="false"
          selectType="selectSearch"
          :value.sync="record.itemCode"
          requestApi="/mdm/mdmItemSystemItem/itemCodeBox"
          :selectItem="{ value: 'realValue', label: 'label' }"
          searchParam="itemCode"
          :allowClear="false"
          sourseField="res"
          @change="(val, list) => itemIdChange(val, list, index)"
        />
      </template>
      <!-- 物料名称 -->
      <template slot="itemName" slot-scope="text, record">
        <a-input v-model="record['itemName']" disabled />
      </template>
      <!-- 安全库存水位 -->
      <span slot="safetyStockLevelTitle">
        <i class="toRequired">*</i>安全库存水位
      </span>
      <template slot="safetyStockLevel" slot-scope="text, record">
        <a-input-number v-model="record['safetyStockLevel']" :min="1" :precision="0" />
      </template>
      <!-- 输入框 -->
      <template slot="input" slot-scope="text, record, index, column">
        <a-input v-model="record[column.dataIndex]" />
      </template>
      <!-- 删除 -->
      <template slot="operation" slot-scope="text, record">
        <a @click="handleDelete(tableList, record)">删除</a>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'
import { apiAddOrderSatisfyRate, apiAddInvSafetyStockLevel, apiInvDeliveryProductsAdd } from '@/api/mes/scheduling-plan/order-satisfaction-rate'
// 表单字段
export default {
  name: 'OrderSatisfactionRateAdd',
  props: {
    // 计算方式枚举
    calculationTypeList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [],
      // 订单满足率
      columns1: [
        {
          // title: '计划类型',
          width: 160,
          dataIndex: 'planType',
          scopedSlots: { customRender: 'planType', title: "planTypeTitle" }
        },
        {
          title: '仓库',
          width: 160,
          dataIndex: 'warehouse',
          scopedSlots: { customRender: 'warehouse' }
        },
        {
          // title: '存货区域',
          width: 160,
          dataIndex: 'areaCode',
          scopedSlots: { customRender: 'areaCode', title: "maintenanceValueTitle" }
        },
        {
          // title: '订单满足率',
          width: 160,
          dataIndex: 'satisfyRate',
          scopedSlots: { customRender: 'satisfyRate', title: "satisfyRateTitle" }
        },
        {
          // title: '欠货天数',
          width: 100,
          dataIndex: 'oweGoodsDay',
          scopedSlots: { customRender: 'oweGoodsDay', title: "oweGoodsDayTitle" }
        },
        {
          // title: '计算方式',
          width: 160,
          dataIndex: 'calculationType',
          scopedSlots: { customRender: 'calculationType', title: "calculationTypeTitle" }
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      // 安全库存水位
      columns2: [
        {
          // title: '物料编码',
          width: 160,
          dataIndex: 'itemCode',
          scopedSlots: { customRender: 'itemCode', title: "itemIdTitle" }
        },
        {
          title: '物料名称',
          width: 160,
          dataIndex: 'itemName',
          scopedSlots: { customRender: 'itemName' }
        },
        {
          // title: '安全库存水位',
          width: 170,
          dataIndex: 'safetyStockLevel',
          scopedSlots: { customRender: 'safetyStockLevel', title: "safetyStockLevelTitle" }
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      // 快递类产品维护
      columns3: [
        {
          // 物料编码
          width: 160,
          dataIndex: 'itemCode',
          scopedSlots: { customRender: 'input', title: "itemIdTitle" }
        },
        {
          // 订单满足率
          width: 160,
          dataIndex: 'satisfyRate',
          scopedSlots: { customRender: 'input', title: "satisfyRateTitle" }
        },
        {
          // title: '欠货天数',
          width: 160,
          dataIndex: 'oweGoodsDay',
          scopedSlots: { customRender: 'oweGoodsDay', title: "oweGoodsDayTitle" }
        },
        {
          // title: '计算方式',
          width: 160,
          dataIndex: 'calculationType',
          scopedSlots: { customRender: 'calculationType', title: "calculationTypeTitle" }
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      tableList: [],
      currentTab: "订单满足率",
      tableX: 800,
      ptList: ["1", "2"] // 计划类型是分仓计划和调拨计划时，仓库置灰
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {},
  methods: {
    // 物料编码
    itemIdChange (val, list, index) {
      const selectedItem = list.find(item => item.realValue === val)
      const tableList = JSON.parse(JSON.stringify(this.tableList))
      tableList[index].itemName = selectedItem.bringOutDataTwo
      tableList[index].itemId = selectedItem.realValue
      this.tableList = tableList
    },
    // 计划类型
    planTypeChange (record) {
      record.warehouse = ""
    },
    // 删除
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show (val) {
      this.currentTab = val
      if (this.currentTab === "订单满足率") {
        this.columns = JSON.parse(JSON.stringify(this.columns1))
        this.tableX = 800
      }
      if (this.currentTab === "安全库存水位") {
        this.columns = JSON.parse(JSON.stringify(this.columns2))
        this.tableX = 600
      }
      if (this.currentTab === "快递类产品维护") {
        this.columns = JSON.parse(JSON.stringify(this.columns3))
        this.tableX = 600
      }
      this.addLine()
      this.visible = true
    },
    // 新增行
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.tableList))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      let obj = {}
      if (this.currentTab === "快递类产品维护") {
        obj = {
          itemCode: '',
          satisfyRate: ''
        }
      } else {
        obj = {
          planType: "",
          warehouse: "",
          areaCode: "",
          satisfyRate: "",
          itemId: "",
          itemCode: "",
          itemName: "",
          safetyStockLevel: "",
          indexId: Number(indexId) + 1
        }
      }
      if(['订单满足率', '快递类产品维护'].includes(this.currentTab)) {
        obj.oweGoodsDay = '';
        obj.calculationType = '';
      }
      arr.push(obj)
      this.tableList = arr
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 保存
    confirm () {
      let flag = false
      for (let i = 0; i < this.tableList.length; i++) {
        // 订单满足率
        if (this.currentTab === "订单满足率") {
          if (!this.tableList[i].planType || !this.tableList[i].areaCode) {
            this.$message.warning('必填项不能为空！')
            flag = true
            return
          }
          if (!this.tableList[i].satisfyRate && String(this.tableList[i].satisfyRate) !== '0') {
            this.$message.error(`第${i + 1}行，订单满足率不能为空`)
            return
          }
          if (!this.tableList[i].oweGoodsDay && String(this.tableList[i].oweGoodsDay) !== '0') {
            this.$message.error(`第${i + 1}行，欠货天数不能为空`)
            return
          }
          if (!this.tableList[i].calculationType) {
            this.$message.error(`第${i + 1}行，计算方式不能为空`)
            return
          }
        }
        // 安全库存水位
        if (this.currentTab === "安全库存水位") {
          if (!this.tableList[i].itemCode) {
            this.$message.warning('必填项不能为空！')
            flag = true
            return
          }
          if (!this.tableList[i].safetyStockLevel) {
            this.$message.error(`第${i + 1}行，安全库存水位不能为空`)
            return
          }
        }
        // 快递类产品维护
        if (this.currentTab === "快递类产品维护") {
          if (!this.tableList[i].itemCode) {
            this.$message.warning('物料编码不能为空！')
            flag = true
            return
          }
          if (!this.tableList[i].satisfyRate) {
            this.$message.warning('订单满足率不能为空！')
            flag = true
            return
          }
          if (!this.tableList[i].oweGoodsDay && String(this.tableList[i].oweGoodsDay) !== '0') {
            this.$message.warning(`第${i + 1}行，欠货天数不能为空`)
            flag = true
            return
          }
          if (!this.tableList[i].calculationType) {
            this.$message.warning(`第${i + 1}行，计算方式不能为空`)
            flag = true
            return
          }
        }
      }
      if (flag) {
        return false
      }
      // 订单满足率
      if (this.currentTab === "订单满足率") {
        this.confirmLoading = true
        apiAddOrderSatisfyRate(this.tableList).then(response => {
          if (response.code === 200) {
            this.$message.success('新增成功')
            // 关闭本组件
            this.visible = false
            // 调用外部刷新列表方法
            this.$emit('handle-success')
            // 刷新表单
            this.reset()
            this.confirmLoading = false
          } else {
            this.$message.error(response.msg)
            this.confirmLoading = false
          }
        }).catch(e => {
          this.confirmLoading = false
        })
      }
      // 安全库存水位
      if (this.currentTab === "安全库存水位") {
        this.confirmLoading = true
        apiAddInvSafetyStockLevel(this.tableList).then(response => {
          if (response.code === 200) {
            this.$message.success('新增成功')
            // 关闭本组件
            this.visible = false
            // 调用外部刷新列表方法
            this.$emit('handle-success')
            // 刷新表单
            this.reset()
            this.confirmLoading = false
          } else {
            this.$message.error(response.msg)
            this.confirmLoading = false
          }
        }).catch(e => {
          this.confirmLoading = false
        })
      }
      // 快递类产品维护
      if (this.currentTab === "快递类产品维护") {
        apiInvDeliveryProductsAdd(this.tableList).then(response => {
          if (response.code === 200) {
            this.$message.success('新增成功')
            // 关闭本组件
            this.visible = false
            // 调用外部刷新列表方法
            this.$emit('handle-success')
            // 刷新表单
            this.reset()
            this.confirmLoading = false
          } else {
            this.$message.error(response.msg)
            this.confirmLoading = false
          }
        }).catch(e => {
          this.confirmLoading = false
        })
      }
    },
    // 表单重置
    reset () {
      this.tableList = []
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select{
  width: 150px;
}
/deep/.ant-input-number{
  width: 150px;
}
input{
  width: 150px;
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
</style>
